import script from "./PaymentContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentContainer.vue?vue&type=script&setup=true&lang=js"

import "./PaymentContainer.vue?vue&type=style&index=0&id=0edb231a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0edb231a"]])

export default __exports__